.header {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.left,
.right {
  display: flex;
  gap: 8px;
  align-items: center;
  min-width: 0;
}

.left {
  gap: 16px;
}

.search {
  width: 240px;
}

.userInfo {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 4px 8px;
  font: inherit;
  color: inherit;
  cursor: pointer;
  background: transparent;
  border: none;
  border-radius: var(--ant-border-radius);
}

.userInfo:hover {
  background: var(--ant-color-fill-tertiary);
}

.userDetails {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.3;
}

.userName {
  font-size: 14px;
  font-weight: 500;
  color: var(--ant-color-text);
}

.userRole,
.userCardMeta {
  font-size: 12px;
  color: var(--ant-color-text-secondary);
}

.dropdownIcon {
  font-size: 12px;
  color: var(--ant-color-text-tertiary);
}

.userCard {
  min-width: 180px;
  cursor: default;
}

.userCardName {
  font-weight: 600;
  color: var(--ant-color-text);
}

@media (width <= 768px) {
  .search,
  .userDetails {
    display: none;
  }
}
